import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { db } from '../Firebase';
import { doc, getDoc } from 'firebase/firestore';
import { FiClock, FiArrowLeft, FiCheck } from 'react-icons/fi';
import './BlogDetailPage.css';

const BlogDetailPage = () => {
  const { blogId } = useParams();
  const navigate = useNavigate();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const docRef = doc(db, 'blogs', blogId);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setBlog({ id: docSnap.id, ...docSnap.data() });
        }
      } catch (err) {
        console.error('Error fetching blog:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchBlog();
  }, [blogId]);

  const renderContent = (content) => {
    if (!content) return null;
    
    // If content is a string, render it as-is with HTML support
    if (typeof content === 'string') {
      return <div className="blog-content-html" dangerouslySetInnerHTML={{ __html: content }} />;
    }
    
    // If content is a React element, render it directly
    return <div className="blog-content-react">{content}</div>;
  };

  const renderDescription = (description) => {
    if (!description) return null;
    
    // Render description as-is with HTML support
    if (typeof description === 'string') {
      return <div className="blog-description-html" dangerouslySetInnerHTML={{ __html: description }} />;
    }
    
    // If it's a React element, render it directly
    return <div className="blog-description-react">{description}</div>;
  };

  if (loading) {
    return (
      <div className="blog-detail-page-wrapper">
        <div style={{ padding: '100px 20px', textAlign: 'center', color: '#64748b' }}>
          <div style={{ fontSize: '2rem', marginBottom: '10px' }}>⏳</div>
          <p>Loading article...</p>
        </div>
      </div>
    );
  }

  if (!blog) {
    return (
      <div className="blog-detail-page-wrapper">
        <div style={{ padding: '100px 20px', textAlign: 'center', color: '#64748b' }}>
          <p>Article not found.</p>
          <button 
            onClick={() => navigate('/blog')}
            style={{
              marginTop: '20px',
              padding: '12px 24px',
              background: 'var(--color-primary)',
              color: '#fff',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontWeight: 600
            }}
          >
            Back to Blog
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="blog-detail-page-wrapper">
      {/* Header Section */}
      <header className="blog-detail-header">
        <div className="blog-detail-header-content">
          <span className="blog-detail-category">{blog.category}</span>
          <h1 className="blog-detail-title">{blog.title}</h1>
          <div className="blog-detail-meta">
            <span className="blog-detail-type">{blog.type}</span>
            <span className="blog-detail-divider">•</span>
            <span className="blog-detail-read-time">
              <FiClock style={{ marginRight: '4px', verticalAlign: 'middle' }} />
              {blog.readTime}
            </span>
          </div>
        </div>
      </header>



      {/* Main Content */}
      <main className="blog-detail-main">
        {/* Back Button */}
        <button
          className="back-button-content"
          onClick={() => navigate('/blog')}
        >
          <FiArrowLeft className="back-icon" />
          Back to Blog
        </button>

        {/* Medium Size Cover Image */}
        {blog.image && (
          <div className="blog-detail-image-container" style={{ textAlign: 'center', marginBottom: '30px' }}>
            <img
              src={blog.image}
              alt={blog.title}
              className="blog-detail-hero-image"
            />
          </div>
        )}

        {/* Description */}
        {blog.description && (
          <div className="blog-detail-description">
            {renderDescription(blog.description)}
          </div>
        )}

        {/* Main Content */}
        <div className="blog-detail-content">
          {renderContent(blog.content)}
        </div>

        {/* Verification Badge */}
        <div className="blog-detail-verification">
          <div className="verification-badge">
            <FiCheck size={14} />
          </div>
          <div>
            <h6>Medical Review Desk</h6>
            <p>
              Reviewed and approved by the Swarup Hospital clinical
              committee for educational accuracy.
            </p>
          </div>
        </div>
      </main>

      {/* Related Articles Section */}
      <section className="blog-detail-related">
        <div className="related-header">
          <h3>More Articles</h3>
          <button
            onClick={() => navigate('/blog')}
            className="view-all-button"
          >
            View All
          </button>
        </div>
      </section>
    </div>
  );
};

export default BlogDetailPage;
